import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=8a3d3894&scoped=true&"
import script from "./Assembly.vue?vue&type=script&lang=js&"
export * from "./Assembly.vue?vue&type=script&lang=js&"
import style0 from "./Assembly.vue?vue&type=style&index=0&id=8a3d3894&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3d3894",
  null
  
)

export default component.exports